module.exports = __webpack_public_path__ + "img/logoverde.67b175a5.png";